import React from 'react';
import {
    Box,
    Button,
    ButtonProps,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogTitleProps,
    IconButton,
    IconButtonProps,
    Link,
    Typography,
    useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import * as Styles from "pages/employee/certificates/certificateDetails/certificateDetails.styles";
import FileUpload from 'components/formsUI/FileUpload';
import * as certificateService from 'services/certificate-service';

interface IProps {
    open: boolean;
    onClose: (event: any, reason: string) => void;
    handleClosePositive: () => void;
    signingInProgress: boolean;
    errorPositive: boolean;
    errorMessage: string;
    handleConfirmPositive: () => void;
    certificate: CertificateWithDetails;
    resetCert: () => void;
    setCertificate: React.Dispatch<React.SetStateAction<CertificateWithDetails | undefined>>;
    showMessage: MessageBox;
}

const PositiveSignModal = (props: IProps) => {
    const {
        open,
        onClose,
        handleClosePositive,
        signingInProgress,
        errorPositive,
        errorMessage,
        handleConfirmPositive,
        certificate,
        resetCert,
        setCertificate
    } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    const [readySign, setReadySign] = React.useState<boolean>(false);

    const handleDownload = () => {
        certificateService.getSignedFile(certificate.id).then((res: Blob) => {
            if (res !== undefined) {
                var fileUrl = URL.createObjectURL(res);
                var fileName = "unknown.pdf";
                if (certificate) {
                    fileName = certificate.certificateSignedFile.substring(certificate.certificateSignedFile.indexOf("_") + 1);
                }
                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = fileName;
                link.click();
            }
        });
    }

    const handleUploadFile = (value: any, finished: boolean) => {
        if (finished) {
            setReadySign(true);
        }
    }

    const handleSignFile = () => {
        certificateService.approveCertificate(certificate.id).then((res: any) => {
            if (res !== undefined) {
                setCertificate(undefined)
                resetCert();
                handleClosePositive();
            }
        });
    }

    const statusDialogTitle: DialogTitleProps = {
        sx: Styles.statusDialogTitle(theme)
    };

    const closeDialogIconButton: IconButtonProps = {
        sx: Styles.closeDialogIconButton(theme)
    };

    const statusDialogCancelButton: ButtonProps = {
        variant: "contained",
        sx: Styles.statusDialogCancelButton(theme)
    };

    return (
        <Dialog
            fullWidth
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogTitle {...statusDialogTitle}>
                {t("certificateWithDetail.positive.title")}
                <IconButton
                    {...closeDialogIconButton}
                    aria-label="close"
                    onClick={handleClosePositive}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{ textAlign: "center" }}>
                {
                    certificate.packageId ?
                        <Typography variant="body2" gutterBottom>
                            {t("certificateWithDetail.positive.info")}
                        </Typography> :
                        <Box>
                            <Typography variant="body2" gutterBottom>
                                {t("certificateWithDetail.positive.manualInfo1")}
                                <Link onClick={handleDownload} href="#">{t('certificateWithDetail.positive.attest')}</Link>
                                {t("certificateWithDetail.positive.manualInfo2")}
                            </Typography>
                            <FileUpload
                                setFilesUploaded={console.log}
                                getFilesChanged={handleUploadFile}
                                showMessage={props.showMessage}
                                title=''
                                textUpload={t('certificateWithDetail.positive.textUpload')}
                                isStep5={true}
                                isCertificates={true}
                                isSignedFile={true}
                                allowedFiles={['pdf']}
                            />
                        </Box>
                }
                {/* <Typography variant="body2" gutterBottom>
                    {certificate.packageId ? t("certificateWithDetail.positive.info") : t('certificateWithDetail.positive.manualInfo')}
                </Typography> */}
                {signingInProgress === true && <CircularProgress />}
                {errorPositive && <Box color="error.main" marginTop="5px"> {errorMessage}</Box>}
            </DialogContent>
            <DialogActions>
                <Button {...statusDialogCancelButton} onClick={handleClosePositive}>
                    {t("certificateWithDetail.closeButton")}
                </Button>
                {certificate.packageId ?
                    <Button variant="contained" color="success" autoFocus onClick={handleConfirmPositive}>
                        {t("certificateWithDetail.signButton")}
                    </Button> :
                    <Button variant="contained" disabled={!readySign} color="success" autoFocus onClick={handleSignFile}>
                        {t("certificateWithDetail.signButton")}
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
};

export default PositiveSignModal;